import type { FaireProductEntity } from "../../entity_types/product";

export const p_vk4vqdtbyq: FaireProductEntity = {
  token: "p_vk4vqdtbyq",
  type: "product",
  name: "Heirloom Tomato Candle",
  brandToken: "b_v27n87y2qb",
  brandName: "Candle Lume",
  imageUrl:
    "https://cdn.faire.com/fastly/eeadb2ec075302a0dfdf99f9338674a69b8ddce651525e178921169427d020cf.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3c2e7af8846118c6047e7732904b7382e51b5a33b54d2895c0815f7599f10b0d.jpeg",
    "https://cdn.faire.com/fastly/ead96ab63c4fbd35d849920963227b083fa4e7a2495171127504e8ee9ef08af6.jpeg",
    "https://cdn.faire.com/fastly/bf0bb44a41d1a99a520c58404496aadfba01d4deb57e6c39a9391433007518d6.jpeg",
    "https://cdn.faire.com/fastly/87a2bb334358c616e28ca0ca292e83357c8e73c8cec754020408f494a39bd4ca.jpeg",
    "https://cdn.faire.com/fastly/817e61028a517e7921b1bb1475b14f7d3014971399bd5bcce18107e594a70d6f.jpeg",
    "https://cdn.faire.com/fastly/d5c5a99f31930d22644a19f27c5370d228612e730da107f2292dd155780d5857.jpeg",
    "https://cdn.faire.com/fastly/2fd3edca149da4a11755109b8ac6ea0bee9e50d0ef647087e5e20caf5f4e7b7a.jpeg",
  ],
  priceDollars: 8.4,
  description:
    'Unexpected in the best way, this candle leans into the quiet beauty of a perfectly imperfect tomato. Earthy, fresh, and just a little nostalgic, it brings a subtle garden touch indoors.\n\nHand-poured using premium, all-natural beeswax and a cotton wick, this decorative candle offers a clean, even burn while balancing sculptural impact with refined craftsmanship.\n\n\nScent: Unscented\n\nDetails\nDimensions: 3.5" L x 3.5" W x 3" H\nNet Weight: 250g\nWax type: Beeswax\n\n\n',
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:56.357Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
